import React, { useState, useEffect } from "react";
import RestService from "../../Restservice";
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "../../component/Loader";
import OptionchainData from "../optionchain/OptionchainData";

const useStyles = makeStyles((theme) => ({
  box: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "10px 10px 0",
  },
  paramargin: {
    margin: "0px",
  },
  para: {
    fontWeight: "bold",
    width: "80px",
  },
  setSelect: {
    width: "150px",
    display: "inline-block",
    marginLeft: "10px",
  },
}));

export default function OptionChainData({ symbol }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [dateType, setdateType] = useState("both");
  const [globaldata, setglobaldata] = useState(false);
  const [expdate, setExpdate] = useState(false);
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getOptionchainTechData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
      },
      mobile,
      web_token,
      symbol,
      dateType,
      expdate
    );
  }, [mobile, web_token, symbol, dateType, expdate]);

  const filterDataType = (eventtype) => {
    setdateType(eventtype);
  };

  const getExpiryDate = (event) => {
    setExpdate(event.value);
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="row">
        <div className="col-sm-6">
          <button
            className={
              dateType === "ce"
                ? "btn btn-success mr-2"
                : "btn btn-default mr-2"
            }
            onClick={(event) => filterDataType("ce")}
          >
            Call
          </button>
          <button
            className={
              dateType === "pe"
                ? "btn btn-success mr-2"
                : "btn btn-default mr-2"
            }
            onClick={(event) => filterDataType("pe")}
          >
            Put
          </button>
          <button
            className={
              dateType === "both"
                ? "btn btn-success mr-2"
                : "btn btn-default mr-2"
            }
            onClick={(event) => filterDataType("both")}
          >
            Both
          </button>
        </div>
        <div className="col-sm-6 text-right">
          <Select
            onChange={getExpiryDate}
            options={globaldata.allDate ? globaldata.allDate : []}
            name="expiry_date"
            className={classes.setSelect + " select-option"}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-comodity">
            {globaldata.getDetails && globaldata.getDetails.length > 0 ? (
              <OptionchainData
                getDetails={globaldata.getDetails}
                dateType={dateType}
                ltp={globaldata.frontData.ltp}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
}
